import { env } from 'node:process';

/**
 * The base URL for the Smartling API.
 */
export const SMARTLING_BASE_URL: string | undefined = env.SMARTLING_BASE_URL;

/**
 * The specific auth path accordingly Smartling API.
 */
export const SMARTLING_AUTH_PATH: string | undefined = env.SMARTLING_AUTH_PATH;

/**
 * The specific files path accordingly Smartling API.
 */
export const SMARTLING_FILES_PATH: string | undefined =
  env.SMARTLING_FILES_PATH;

/**
 * The specific strings path accordingly Smartling API.
 */
export const SMARTLING_STRINGS_PATH: string | undefined =
  env.SMARTLING_STRINGS_PATH;

/**
 * The specific context path accordingly Smartling API.
 */
export const SMARTLING_CONTEXT_PATH: string | undefined =
  env.SMARTLING_CONTEXT_PATH;

/**
 * The API user id for Smartling.
 */
export const SMARTLING_API_USER: string | undefined = env.SMARTLING_API_USER;

/**
 * The API user secret for Smartling.
 */
export const SMARTLING_API_SECRET: string | undefined =
  env.SMARTLING_API_SECRET;

/**
 * The project ID for Smartling.
 */
export const SMARTLING_PROJECT_ID: string | undefined =
  env.SMARTLING_PROJECT_ID;

/**
 * The specific projects path accordingly to Smartling API.
 */
export const SMARTLING_PROJECTS_PATH: string | undefined =
  env.SMARTLING_PROJECTS_PATH;

/**
 * The specific jobs path accordingly Smartling API.
 */
export const SMARTLING_JOBS_PATH = env.SMARTLING_JOBS_PATH;
export const SMARTLING_LOCALES_PATH = env.SMARTLING_LOCALES_PATH;

/**
 * Default locale used to locate translation .ftl files
 */
export const DEFAULT_LOCALE = env.DEFAULT_LOCALE ?? 'en-US';

/**
 * You should avoid using this list unless you have a good reason to do so.
 * This list is used to ignore certain directories that are not relevant to the screenshots check,
 * or are already existing projects in the repo which still don't meet the requirements to pass this check.
 */
export const SCREENSHOT_CHECK_EXCEPTIONS = [
  '/packages/app-core/**',
  '/packages/powerdialer/**',
];

/**
 * Maximum number of items returned by smartling API call
 * https://api-reference.smartling.com/#tag/Strings/operation/getAllSourceStringsByProject
 */
export const STRINGS_PAGE_SIZE = 500;

/**
 * This constant indicates if the workaround for fixing the issue of not allowing a
 * key with only attributes and no value should be used.
 * This workaround consists on injecting: {placeholder} as value onto those strings.
 */
export const INJECT_PLACEHOLDER_WORKAROUND = Boolean(
  env.INJECT_PLACEHOLDER_WORKAROUND,
);

/**
 * The placeholder value to be injected on the Smartling workaround
 */
export const INJECTABLE_WORKAROUND_VALUE = '{placeholder}';
